// This is a part of the Cadcorp SIS source code. 
// Copyright (c) NEC Software Solutions UK Limited 1991-2026 
import { ISchemaColumn } from '../../../../CommonScripts/Abstractions';
/**
* Represents a schema column for an overlay served from the GeognoSIS http interface
* @public
*/
export class SchemaColumn implements ISchemaColumn {
    /**
    * @public
    * @property {string} name The name of this schema column, retrieved from the _description$ property
    */
    name : string;
    /**
    * @public
    * @property {string} expression The expression of this schema column, retrieved from the _formula$ property
    */
    expression: string;
    /**
    * @public
    * @property {boolean} isMapTip True if this column is defined as a maptip, otherwise false. Retrieved from the _bMapTip& property
    */
    isMapTip: boolean;
    /**
    * @public
    * @property {boolean} isHidden True if this column is hidden, otherwise false. Retrieved from the _bHidden& property
    */
    isHidden: boolean;

    /**
    * @public
    * @property {number} type The type of this schema column. Retrieved from the _type& property
    */
    type: number;

    /**
    * @public
    * @property {string} typeName The name for the type of this schema column. Retrieved from the _typeName$ property
    */
    typeName : string;
    /**
    * @property {number} columnIndex - The index of this schema
    * @public
    */
    columnIndex: number;

    /**
    * Initialises a new instance of SchemaColumn
    * @constructor
    * @public
    * @param {ISchemaColumn} config The configuration for this object
    */
    constructor(config: ISchemaColumn) {
        this.name = config.name;
        this.columnIndex = config.columnIndex;
        this.expression = config.expression;
        this.isHidden = config.isHidden;
        this.isMapTip = config.isMapTip;
        this.type = config.type;
        this.typeName = config.typeName;
    }
}


